<!--
  An empty area (DESIGN.md §6.10): the girih star, one sentence saying what
  will appear here, and (in the slot) one primary action when the user can
  create it. Used by lists and tables when they have nothing to show.
-->
<script lang="ts">
  import type { IntlString } from '@hcengineering/platform'
  import Label from './Label.svelte'

  export let label: IntlString
  export let labelParams: Record<string, any> = {}
</script>

<div class="fz-empty">
  <svg class="fz-empty__star" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" aria-hidden="true">
    <polygon
      points="12.00,2.00 9.07,4.93 4.93,4.93 4.93,9.07 2.00,12.00 4.93,14.93 4.93,19.07 9.07,19.07 12.00,22.00 14.93,19.07 19.07,19.07 19.07,14.93 22.00,12.00 19.07,9.07 19.07,4.93 14.93,4.93"
    />
  </svg>
  <span class="fz-empty__text"><Label {label} params={labelParams} /></span>
  {#if $$slots.default}
    <div class="fz-empty__action"><slot /></div>
  {/if}
</div>

<style lang="scss">
  .fz-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--fz-space-3);
    padding: var(--fz-space-12) var(--fz-space-6);
    text-align: center;
  }
  .fz-empty__star {
    width: 2.5rem;
    height: 2.5rem;
    color: var(--fz-border-strong);
  }
  .fz-empty__text {
    font-size: var(--fz-type-body-size);
    line-height: var(--fz-type-body-line);
    color: var(--fz-text-secondary);
  }
  .fz-empty__action {
    margin-top: var(--fz-space-1);
  }
</style>
